import React, { useMemo } from 'react';
import './style.scss';
import clsx from 'clsx';
import Loader from '../../loader';

interface ButtonProps {
  children?: React.ReactNode;
  onClick?: (...args: any[]) => any;
  className?: string;
  variant?: 'contained' | 'outlined';
  color?: 'primary' | 'secondary' | 'default' | 'black';
  disabled?: boolean;
  loading?: boolean;
}

const Button = ({
  children,
  onClick,
  className = '',
  variant = 'contained',
  color = 'primary',
  disabled = false,
  loading = false
}: ButtonProps) => {
  const finalClassName = useMemo(() => {
    return clsx(
      'button',
      `button-${variant}`,
      `button-${color}`,
      disabled && 'button-disabled'
    );
  }, [className, variant, color, disabled]);

  const handleClick = (e: any) => {
    if (onClick) onClick(e);
  };

  return (
    <button
      onClick={disabled || loading ? undefined : handleClick}
      className={clsx(finalClassName, className)}
      disabled={disabled}
    >
      <div
        className={clsx('button-content', loading && 'button-content-hidden')}
      >
        {children}
      </div>
      {loading && <Loader color='white' size={35} useAbsoluteWrapper />}
    </button>
  );
};

export default Button;
